import { BaseWidget } from "../widgets";
import { CanvasNode } from "./CanvasNode";
import { CanvasEndDropZone } from "./CanvasEndDropZone";
import LiveReportRenderContext from "../../../../StateManagment/LiveReportRenderContext";

/**
 * Canvas component that renders all widgets in the live report builder.
 * 
 * @param {object} props
 * @param {BaseWidget} [props.rootNode] The root widget node to render
 * @param {BaseWidget[]} props.widgets List of all widgets to render
 * @param {boolean} [props.editable=true] Whether the canvas is in editable mode (clicking sets active widget) or read-only mode
 * @returns 
 */
export const Canvas = ({
    rootNode,
    widgets,
    editable = true,
}) => {

    if (!rootNode) {
        return null;
    }

    return (
        <LiveReportRenderContext.Provider value={true}>
            <div className={`report-builder-canvas ${editable ? 'editable' : 'read-only'}`}>
                <CanvasNode
                    key={rootNode.id}
                    widget={rootNode}
                    widgets={widgets}
                    editable={editable}
                />
                {editable && <CanvasEndDropZone rootId={rootNode.id} widgets={widgets} />}
            </div>
        </LiveReportRenderContext.Provider>
    );
}
